// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pad-layout {
  background-color: white;
  min-width: 94%;
  margin-right: 3%;
  margin-left: 3%;
  min-height: 13em;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.pad-row {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.pad-main {
  flex: 1 1 100%;
  width: 100%;
}

.pad-controls {
  gap: 0.5em;
  align-items: center;
}

.pad-cell {
  flex: 1 1 auto;
}

@media (max-width: 600px) {
  .pad-controls .pad-cell {
    flex: 1 1 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pad/padPane.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,cAAc;EAChB;AACF","sourcesContent":[".pad-layout {\r\n  background-color: white;\r\n  min-width: 94%;\r\n  margin-right: 3%;\r\n  margin-left: 3%;\r\n  min-height: 13em;\r\n  display: flex;\r\n  flex-direction: column;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.pad-row {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  width: 100%;\r\n}\r\n\r\n.pad-main {\r\n  flex: 1 1 100%;\r\n  width: 100%;\r\n}\r\n\r\n.pad-controls {\r\n  gap: 0.5em;\r\n  align-items: center;\r\n}\r\n\r\n.pad-cell {\r\n  flex: 1 1 auto;\r\n}\r\n\r\n@media (max-width: 600px) {\r\n  .pad-controls .pad-cell {\r\n    flex: 1 1 100%;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
